import * as Sentry from '@sentry/react';

import { API } from '@/shared/api';

import type { TrialPaywallVariant } from '../lib/types';

import { TRIAL_PAYWALL_VARIANT_KEY } from '../lib/constants';

export const persistTrialPaywallVariant = (variant: TrialPaywallVariant) =>
  API.setItem(TRIAL_PAYWALL_VARIANT_KEY, variant).then(
    () => undefined,
    (error: unknown) => {
      Sentry.captureException(error, { tags: { feature: 'trialPaywallVariant', phase: 'signup-write' } });
    },
  );
